export default __webpack_public_path__ + "static/media/michael.2257e86c.png";